import { getAction, postAction } from "./index.js";

/**
 * 项目统计数量（卡片上方统计条）
 * GET /audit/lxAuditTask/getApplyStatCount?applyType=1
 */
export function getApplyStatCount(params) {
  return getAction("/audit/lxAuditTask/getApplyStatCount", params);
}

/**
 * 思政微课学校/教师端项目总览列表
 * GET /audit/lxAuditTask/getApplyOverviewList
 */
export function getApplyOverviewList(params) {
  return getAction("/audit/lxAuditTask/getApplyOverviewList", params);
}

/** 学校审核 auditLevel=1，审核员/教育局审核 auditLevel=2 */
export function getAuditLevel(role) {
  if (role === "school-role") return 1;
  if (role === "audit-role" || role === "education-role") return 2;
  return undefined;
}

function normalizeLevel(auditLevel) {
  if (
    auditLevel == null ||
    auditLevel === "" ||
    String(auditLevel) === "null" ||
    String(auditLevel) === "NULL" ||
    String(auditLevel) === "undefined"
  ) {
    return null;
  }
  return String(auditLevel);
}

/** 是否处于学校审核阶段（level 非 2） */
export function isSchoolAuditStage(auditLevel) {
  return normalizeLevel(auditLevel) !== "2";
}

/**
 * 两级审核互斥（与列表状态文案一致）：
 * - 学校：仅「待学校审核」（auditState=1 且 level≠2）
 * - 审核员/教育局：仅「待教育局/厅审核」（auditState=1 且 level=2）
 */
export function canRoleAuditAtLevel(role, auditState, auditLevel) {
  if (String(auditState) !== "1") return false;
  const lv = normalizeLevel(auditLevel);
  if (role === "school-role") return lv !== "2";
  if (role === "audit-role" || role === "education-role") return lv === "2";
  return false;
}

/**
 * 变更历史：模块已通过 + 已驳回列表
 * GET /audit/lxAuditTask/getModuleAuditList?applyId=
 */
export function getModuleAuditList(params) {
  return getAction("/audit/lxAuditTask/getModuleAuditList", params);
}

/**
 * 指定版本的项目数据快照（该版本最终生效的完整数据）
 * GET /audit/lxAuditTask/getVersionSnapshot?applyId=&applyType=&version=
 */
export function getVersionSnapshot(params) {
  return getAction("/audit/lxAuditTask/getVersionSnapshot", params);
}

/**
 * 变更请求：模块待审核列表
 * GET /audit/lxAuditTask/getModulePendingAuditList?applyId=
 */
export function getModulePendingAuditList(params) {
  return getAction("/audit/lxAuditTask/getModulePendingAuditList", params);
}

/**
 * 模块变更数量（列表卡片「变更请求」角标）
 * POST /audit/lxAuditTask/getModuleChangeCount?currentVersion=0&applyId=
 * 返回各模块 INSERTNum / UPDATENum / pendingReviewNum 等
 */
export function getModuleChangeCount(applyId, currentVersion = 0) {
  return postAction(
    `/audit/lxAuditTask/getModuleChangeCount?currentVersion=${currentVersion}&applyId=${applyId}`
  );
}

/**
 * 从 getModuleChangeCount 结果中汇总「待审核」数量，供卡片角标使用。
 * includeDraft=true 时把待提交草稿（pendingSubmitNum）也算进去，给教师/学校看。
 */
export function sumPendingReviewNum(result, includeDraft = false) {
  if (!result || typeof result !== "object") return 0;
  let count = 0;
  Object.keys(result).forEach((key) => {
    if (key === "totalNum") return;
    const mod = result[key];
    if (mod && typeof mod === "object") {
      count += Number(mod.pendingReviewNum) || 0;
      if (includeDraft) count += Number(mod.pendingSubmitNum) || 0;
    }
  });
  // 若各模块无 pendingReviewNum，尝试 totalNum 上的字段
  if (count === 0 && result.totalNum) {
    count =
      Number(result.totalNum.pendingReviewNum) ||
      Number(result.totalNum.UPDATENum) ||
      0;
    if (includeDraft) count += Number(result.totalNum.pendingSubmitNum) || 0;
  }
  return count;
}

/**
 * 按批次整批通过/驳回
 * POST /audit/lxAuditTask/batchAuditTask
 * { applyId, batchNumber, auditState: 1|2, remark, auditLevel }
 */
export function auditByBatchNumber(params) {
  return postAction("/audit/lxAuditTask/batchAuditTask", params);
}

/**
 * 项目版本历史（不含 snapshot）
 * GET /lx/lxApply/getVersionHistory?applyId=
 */
export function getVersionHistory(applyId) {
  return getAction("/lx/lxApply/getVersionHistory", { applyId });
}

/**
 * 单个版本详情：解析后的全量现状
 * GET /lx/lxApply/getVersionDetail?versionId=
 */
export function getVersionDetail(versionId) {
  return getAction("/lx/lxApply/getVersionDetail", { versionId });
}

/**
 * 两个已通过版本的全量快照对比
 * GET /lx/lxApply/compareVersions?leftVersionId=&rightVersionId=
 */
export function compareVersions(leftVersionId, rightVersionId) {
  return getAction("/lx/lxApply/compareVersions", {
    leftVersionId,
    rightVersionId,
  });
}

/**
 * 待提交变更清单（audit_state=0）
 * GET /audit/lxAuditTask/getDraftChangeList?applyId=
 */
export function getDraftChangeList(applyId) {
  return getAction("/audit/lxAuditTask/getDraftChangeList", { applyId });
}
